module.exports = __webpack_public_path__ + "img/system_second.32cee3dd.png";